export default "__VITE_ASSET__DNHSYa9M__"